import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    visibility: false,
    add_location_visibility: false,
    table_location: {
      headers: [
        { title: '', key: 'is_active', width: 90, sortable: false },
        { title: '', key: 'image', width: 146, sortable: false },
        { title: Vuetify.locale.t('$vuetify.__General.name'), key: 'name', width: 284, sortable: false },
        { title: Vuetify.locale.t('$vuetify.__General.category'), key: 'categories', width: 284, sortable: false },
        { title: Vuetify.locale.t('$vuetify.__AI.location_and_map.map.title'), key: 'map_name', sortable: false },
        { title: '', key: 'action', width: 30, sortable: false }
      ],
      footer_options: {
        itemsPerPage: 10,
        page: 1
      },
      locations: [],
      categories: [],
      search: '',
      total: 0,
      loading: false,
      options: {}
    },
    table_map: {
      maps: []
    }
  },
  mutations: {
    // Init and reset dialog
    INIT_LOCATION_AND_MAP_DIALOG(state) {
      state.visibility = true
    },
    RESET_LOCATION_AND_MAP_DIALOG(state) {
      state.visibility = false
    },

    // Set data and handle update data
    // location
    SET_LOCATION_AND_MAP_DIALOG_TABLE_OPTIONS(state, payload) {
      state.table_location.footer_options = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_TABLE_CATEGORIES(state, payload) {
      state.table_location.categories = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_LOCATION_TOTAL(state, payload) {
      state.table_location.total = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_LOCATION_LIST(state, payload) {
      state.table_location.footer_options.offset = 0
      state.table_location.locations = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_ADD_LOCATION(state, payload) {
      state.table_location.locations.push(payload)
    },
    SET_LOCATION_AND_MAP_DIALOG_LOCATION_SEARCH(state, payload) {
      state.table_location.search = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_LOCATION_LOADING(state, payload) {
      state.table_location.loading = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_LOCATION_OPTIONS(state, payload) {
      state.table_location.options = payload
    },
    SET_LOCATION_AND_MAP_DIALOG_LOCATION_OPTIONS_PAGE(state, payload) {
      state.table_location.options.page = payload
    },
    // map
    SET_LOCATION_AND_MAP_DIALOG_MAP_LIST(state, payload) {
      state.table_map.maps = payload
    }
  },
  actions: {
    // location
    async fetchLocationList({ commit, rootState, state }) {
      try {
        commit('SET_LOCATION_AND_MAP_DIALOG_LOCATION_LIST', [])
        commit('SET_LOCATION_AND_MAP_DIALOG_LOCATION_LOADING', true)
        const { search, categories } = state.table_location
        const device_id = rootState.auth.selected_device
        const { itemsPerPage, page } = state.table_location.footer_options
        const response = await api.getLocationList({ device_id, search, limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage, category_ids: categories || null })
        if (response.data.success) {
          if (response.data.data.length) {
            commit('SET_LOCATION_AND_MAP_DIALOG_LOCATION_LIST', response.data.data)
            commit('SET_LOCATION_AND_MAP_DIALOG_LOCATION_TOTAL', response.data.total)
          }
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_LOCATION_AND_MAP_DIALOG_LOCATION_LOADING', false)
      }
    },
    // Map
    async fetchMapList({ commit, rootState }) {
      try {
        const device_id = rootState.auth.selected_device
        commit('SET_LOCATION_AND_MAP_DIALOG_MAP_LIST', [])
        const response = await api.getMapList({ device_id })
        if (response.data.success) {
          if (response.data.data.length) commit('SET_LOCATION_AND_MAP_DIALOG_MAP_LIST', response.data.data)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MANAGE_CATEGORY_COLUMN_LOADING', false)
      }
    },

    async onOffLocation({ commit, rootState, dispatch }, payload) {
      try {
        const { is_active, details, location_id } = payload
        const device_id = rootState.auth.selected_device
        let location = {
          is_active: is_active,
          device_id: device_id,
          details: details
        }
        const response = await api.updateLocation({ location_id, params: location })
        if (response.data.success) {
          dispatch('fetchLocationList')
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.success', ''), icon: 'check', timeout: '2000' })
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error, icon: 'close', timeout: '2000' })
      }
    }
  }
}
